function sanitizeFilename(value: string): string {
  return value.replace(/[\/\\:*?"<>|]/g, '-').replace(/\s+/g, ' ').trim();
}

export function getMembersAnalyticsPdfFilename(gymDisplayName: string, dateRange: string): string {
  const base = `${gymDisplayName}-${dateRange}-engagement-report`;
  return `${sanitizeFilename(base)}.pdf`;
}

export function printMembersAnalyticsDocument(gymDisplayName: string, dateRange: string): void {
  const filename = getMembersAnalyticsPdfFilename(gymDisplayName, dateRange);
  const titleWithoutExt = filename.replace(/\.pdf$/i, '');
  const previousTitle = document.title;
  document.title = titleWithoutExt;
  document.body.classList.add('members-analytics-print-mode');
  const cleanup = () => {
    document.title = previousTitle;
    document.body.classList.remove('members-analytics-print-mode');
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);
  window.print();
  window.setTimeout(cleanup, 1000);
}
